import Question from "../../Classes/Question";
import { questionModalSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    open: false,
    questionToAdd: new Question(),
    pendingServices: []
}

export default function questionModalSlice(state = initialState, action) {
    switch (action.type) {
        case questionModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case questionModalSliceDispatch.setQuestionToAdd: {
            return {
                ...state,
                questionToAdd: action.payload
            }
        }
        case questionModalSliceDispatch.setPendingServices: {
            return {
                ...state,
                pendingServices: action.payload
            }
        }
        default:
            return state
    }
}
